<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="报告类型：" prop="report_type">
                <el-select  v-model="model.report_type" placeholder="请选择" style="width: 220px" disabled>
                    <el-option v-for="item in enuObj('month_report_type')" :key="'month_report_type'+item.key" :label="item.title" :value="item.key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="报告时间：" prop="report_date">
                <el-date-picker v-model="model.report_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_date">
                <el-date-picker v-model="model.start_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_date">
                <el-date-picker v-model="model.end_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="数据方式：" prop="unit_type">
                <el-select  v-model="model.unit_type" placeholder="请选择" style="width: 220px">
                    <el-option v-for="item in enuObj('month_report_create_type')" :key="'month_report_create_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择审核人：" prop="zd_sh_id">
                <el-select v-model="model.zd_sh_id" filterable placeholder="请选择" clearable>
                    <el-option
                        v-for="item in shUserList"
                        :key="item.id"
                        :label="item.realname"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getShUserList } from '@/api/user'

export default {
    name: 'monthReportEdit',
    mixins: [editutil],
    props: {
        report_type: {
            type: Number,
            default() {
                return 1;
            }
        },
    },
    data() {
        return {
            model: {
                title: '',
                report_type: '',
                report_date: '',
                start_date: '',
                end_date: '',
                unit_type: '1',
                zd_sh_id: '',
            },
            getObj:{
                url:'/api/admin/monthreport/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['month_report_type', 'month_report_create_type'],
            rules: {
                report_type: [
                    {required: true, message: '报告类型不能为空', trigger: 'blur'}
                ],
                title: [
                    {required: true, message: '标题不能为空', trigger: 'blur'}
                ],
                report_date: [
                    {required: true, message: '报告日期不能为空', trigger: 'blur'}
                ],
                start_date: [
                    {required: true, message: '开始日期不能为空', trigger: 'blur'}
                ],
                end_date: [
                    {required: true, message: '结束日期不能为空', trigger: 'blur'}
                ],
                unit_type: [
                    {required: true, message: '数据方式不能为空', trigger: 'blur'}
                ],
            },
            shUserList: [],
        };
    },
    methods: {
        copyObj(source) {
            if (!source) {
                return null;
            }
            source.report_type = this.report_type+''
            return JSON.parse(JSON.stringify(source));
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/monthreport/save'
                    }
                    config["data"] = this.model;
                    const loading = this.$loading({
                        lock: true,
                        text: '正在执行...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    saveModel(config).then(res=>{
                        loading.close();
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData() {
            this.model.report_type = this.model.report_type +''
            this.model.unit_type = this.model.unit_type +''
        },
        loadOtherData() {
            //加载其他内容， 可重写
            this.getShUserList()
        },
        getShUserList(){
            getShUserList().then(res=>{
                if(res.code == 1){
                    this.shUserList = res.data
                }
            })
        },
    }
};
</script>